import {
  AlignStartVertical,
  AlignCenterHorizontal,
  AlignEndVertical,
  AlignStartHorizontal,
  AlignCenterVertical,
  AlignEndHorizontal,
  GripHorizontal,
  GripVertical,
} from "lucide-react";

type AlignDirection =
  | "left"
  | "right"
  | "top"
  | "bottom"
  | "centerH"
  | "centerV"
  | "distributeH"
  | "distributeV";

interface AlignmentToolbarProps {
  selectedCount: number;
  onAlign: (direction: AlignDirection) => void;
}

const BUTTONS: {
  direction: AlignDirection;
  icon: React.ElementType;
  label: string;
  minSelected: number;
}[] = [
  {
    direction: "left",
    icon: AlignStartVertical,
    label: "Alinear izquierda",
    minSelected: 2,
  },
  {
    direction: "centerH",
    icon: AlignCenterHorizontal,
    label: "Centrar horizontal",
    minSelected: 2,
  },
  {
    direction: "right",
    icon: AlignEndVertical,
    label: "Alinear derecha",
    minSelected: 2,
  },
  {
    direction: "top",
    icon: AlignStartHorizontal,
    label: "Alinear arriba",
    minSelected: 2,
  },
  {
    direction: "centerV",
    icon: AlignCenterVertical,
    label: "Centrar vertical",
    minSelected: 2,
  },
  {
    direction: "bottom",
    icon: AlignEndHorizontal,
    label: "Alinear abajo",
    minSelected: 2,
  },
  {
    direction: "distributeH",
    icon: GripHorizontal,
    label: "Distribuir horizontal",
    minSelected: 3,
  },
  {
    direction: "distributeV",
    icon: GripVertical,
    label: "Distribuir vertical",
    minSelected: 3,
  },
];

export default function AlignmentToolbar({
  selectedCount,
  onAlign,
}: AlignmentToolbarProps) {
  if (selectedCount < 2) return null;

  return (
    <div className="flex items-center gap-0.5 bg-white border border-gray-200 rounded-lg px-1 py-0.5 shadow-sm">
      {BUTTONS.map(({ direction, icon: Icon, label, minSelected }) => (
        <button
          key={direction}
          onClick={() => onAlign(direction)}
          disabled={selectedCount < minSelected}
          className="p-1.5 rounded hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
          title={label}
        >
          <Icon className="w-3.5 h-3.5 text-gray-600" />
        </button>
      ))}
    </div>
  );
}
